module.exports = __webpack_public_path__ + "img/articles_blue.cc547b2d.svg";